import React, {lazy, Suspense, useContext, useEffect, useState} from 'react';
import {Context} from './Helpers/Auth';
import {Switch, Route, Redirect, useHistory} from 'react-router-dom';
import Agendamentos from './pages/Agendamentos';
import Despesas from './pages/Despesas';
import AuthenticatedLayout from './components/Authenticatedlayout';
import Negocios from './pages/Negocios';
import Autenticacao from './pages/Autenticacao';
import Questionarios from './pages/Questionarios';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Prospects from './pages/Prospects';
import Catalogo from './pages/Catalogo';
import Propostas from './pages/Propostas';
import Relatorios from './pages/Relatorios';
import Carrinho from './pages/Carrinho';

import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';

function CustomRoute({isPrivate, noBar, ...rest}) {
    const {authenticated, handleRefresh, logout} = useContext(Context);
    const history = useHistory();
    const token = localStorage.getItem('token');

    if (isPrivate && !authenticated && !token) {
        return <Redirect to="/Autenticacao" />;
    }

    if (noBar) {
        return <Route {...rest} />;
    }

    return (
        <>
            <Route {...rest}></Route>
            {/* <Navbar /> */}
        </>
    );
}

export default function Routes() {
    const {handleRefresh} = useContext(Context);

    useState(() => {
        handleRefresh();
    }, []);

    return (
        <>
            <Suspense
                fallback={
                    <div
                        style={{
                            width: '100vw',
                            height: '100vh',
                            display: 'grid',
                            placeItems: 'center',
                            backgroundColor: 'black',
                        }}></div>
                }>
                <ToastContainer />
                <Switch>
                    <Route exact path="/">
                        <Redirect to="/Autenticacao" />
                    </Route>
                    <CustomRoute noBar path="/Autenticacao" component={Autenticacao} />
                    {/* <CustomRoute noBar exact path="/Autenticacao" component={Autenticacao} /> */}
                    <AuthenticatedLayout>
                        <CustomRoute exact path="/Dashboard" component={Dashboard} />
                        <CustomRoute isPrivate path="/Agendamentos" component={Agendamentos} />
                        <CustomRoute isPrivate path="/Carrinho" component={Carrinho} />

                        <CustomRoute isPrivate path="/Catalogo" component={Catalogo} />
                        <CustomRoute isPrivate path="/Leads" component={Leads} />
                        <CustomRoute isPrivate path="/Prospects" component={Prospects} />
                        <CustomRoute isPrivate path="/Propostas" component={Propostas} />
                        <CustomRoute isPrivate path="/Despesas" component={Despesas} />
                        <CustomRoute isPrivate path="/NegociosEtapas" component={Negocios} />
                        <CustomRoute isPrivate path="/Questionarios" component={Questionarios} />
                        <CustomRoute isPrivate path="/Relatorios" component={Relatorios} />
                    </AuthenticatedLayout>
                </Switch>
            </Suspense>
        </>
    );
}
